import Login from "@pages-components/login";

export default Login;
